module.exports = "/packs/images/social_society~01aaf21d96066522130104bde9591651.png";